export default __webpack_public_path__ + "static/media/slide_ux_transparent.804d252e.png";